<template>
  <div class="home" v-loading="loading">
    <div class="home-header">
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/about-header-0.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/about-header-1.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/about-header-2.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/about-header-3.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/about-header-4.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/about-header-5.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/about-header-6.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/about-header-7.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/about-header-8.png"
        alt=""
      />
    </div>
    <div class="company-introduce">
      <div class="company-introduce-left">
        <span class="introduce-title">{{
          isChinese ? "公司介绍" : "Company Introduction"
        }}</span>
        <span class="introduce-content">{{
          isChinese
            ? "宁波渔遥科技有限公司是AI和卫星技术领域的高新技术企业，公司拥有实力雄厚的国际化产品研发和运营团队，包括国家特聘专家、省级特聘专家及人工智能、海洋遥感和渔业资源等领域的国际知名专家。在加拿大渥太华设有分支机构。"
            : "Ningbo Yuyao Technology Co., Ltd. is a high-tech enterprise in the fields of AI and satellite technology. The company has a strong international product research and development and operation team, including nationally appointed experts, provincial-level appointed experts, and internationally renowned experts in artificial intelligence, ocean remote sensing, and fishery resources. We have a branch office in Ottawa, Canada."
        }}</span>
      </div>
      <div class="company-introduce-right">
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/intro.png"
          alt=""
        />
      </div>
    </div>
    <div class="company-news">
      <span class="news-title">{{
        isChinese ? "公司新闻" : "Company News"
      }}</span>
      <div v-for="(news, idx) in newsList" :key="idx" class="new-container">
        <div :class="diamondClass(idx)"></div>
        <div :class="contentClass(idx)">{{ news.content }}</div>
      </div>
    </div>
  </div>
</template>
 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      loading: false,
      caseList: [],
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "horizontal", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        // autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        // slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        // mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        // mousewheelControl: true, //同上
        // height: 500, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        pagination: {
          el: ".swiper-pagination",
        },
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        },
      },
    };
  },
  created() {},
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    ...mapState(["isChinese"]),
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    newsList() {
      return [
        {
          content: this.isChinese
            ? "公司产品“渔遥渔鹰”为百洋股份(股票代码:002696)子公司广西祥和顺捕捞有限公司提供精准渔场预报服务，作业海域:西非毛里塔尼亚海域，捕捞鱼种:章鱼、鱿鱼和沙丁鱼等。"
            : `The company's product "FishAwk" provides Guangxi Xiangheshun Fishing Co., Ltd., a subsidiary of Baiyang Co., Ltd. (stock code: 002696), with precision fishing ground forecasting services. The operating area is the sea area of Mauritania in West Africa, and the species of fish captured are octopus, squid, sardine, etc.`,
        },
        {
          content: this.isChinese
            ? "公司与海南天宇集团科技有限公司合作，利用“渔遥渔鹰”在南海指导鱿鱼，金枪鱼和池鱼等生产作业。"
            : `The company cooperates with Hainan Tianyu Group Technology Co., Ltd. to use the "FishAwk" to guide the production operations of squid, tuna, and pond fish in the South China Sea.`,
        },
        {
          content: this.isChinese
            ? "公司项目“空天海协同渔场预报服务平台”分别入选宁波市和鄞州区高层次人才项目。"
            : `The company's project "Aerospace and Sea Cooperation Same Fishery Forecasting Service Platform" has been selected as a high-level talent project in Ningbo City and Yinzhou District respectively.`,
        },
        {
          content: this.isChinese
            ? "公司分别获青岛甬成创业投资基金和宁波天使投资基金风险投资。"
            : `The company has received venture capital from Qingdao Yongcheng Venture Capital Fund and Ningbo Angel Investment Fund respectively.`,
        },
        {
          content: this.isChinese
            ? "宁波渔遥科技有限公司入选高新技术企业。"
            : `Ningbo Yuyao Technology Co., Ltd. has been selected as a high-tech enterprise.`,
        },
        {
          content: this.isChinese
            ? "宁波渔遥科技有限公司在宁波股权交易中心挂牌(挂牌代码:784055)。"
            : `Ningbo Yuyao Technology Co., Ltd. is listed on the Ningbo Equity Exchange (Stock Code: 784055).`,
        },
      ];
    },
  },
  methods: {
    diamondClass(idx) {
      return idx % 2 == 0 ? "diamond" : "diamond odd-diamond";
    },
    contentClass(idx) {
      return idx % 2 == 0 ? "news-content even-content" : "news-content";
    },
  },
  mounted() {
    // this.$http
    //   .all([
    //     this.$http.get("Cases/GetCasesAll"),
    //     this.$http.get(`News?type=1&num=3`)
    //   ])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    //       this.loading = false;
    //     })
    //   );
  },
};
</script>
 
<style lang="scss" scoped>
.home {
  // height: 2600px;
  padding-bottom: 200px;
}
.home-header {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  img {
    width: calc(100% / 3);
  }
  // height: 600px;
}
.company-introduce {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  box-sizing: border-box;
  gap: 50px;

  /* 阶段1：宽度>X时的动态padding */
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  margin-top: 200px;
  .company-introduce-left {
    display: flex;
    flex-direction: column;
    // flex: 1;
    // min-width: 0;

    box-sizing: border-box;
    flex-shrink: 0;
    flex: 1 1 50%; // 允许伸缩，基础宽度50%
    min-width: 0;

    // width: 400px;
    .introduce-title {
      font-size: var(--titleFontSize);
      font-weight: bold;
      font-style: italic;
      margin-bottom: 50px;
      color: rgb(4, 109, 209);
    }
    .introduce-content {
      font-size: var(--contentFontSize);
      color: rgb(10, 113, 210);
      word-wrap: break-word;
    }
  }
  .company-introduce-right {
    box-sizing: border-box;
    flex: 1 1 50%; // 允许伸缩，基础宽度50%
    min-width: 0;
    margin-top: 110px;
    img {
      width: 100%;
    }
  }
}

.company-news {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-width: var(--breakpoint-z);
  box-sizing: border-box;
  gap: 50px;

  /* 阶段1：宽度>X时的动态padding */
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  margin-top: 200px;
  .news-title {
    font-size: var(--titleFontSize);
    font-weight: bold;
    font-style: italic;
    color: rgb(4, 109, 209);
  }
  .new-container {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    gap: 100px;
    .diamond {
      min-width: 20px; /* 控制菱形大小 */
      min-height: 20px;
      border: 1px solid rgb(10, 113, 210);
      transform: rotate(45deg); /* 关键旋转属性 */
    }
    .odd-diamond {
      color: rgb(4, 109, 209);
      background-color: rgb(4, 109, 209);
    }
    .news-content {
      font-size: var(--contentFontSize);
      color: rgb(10, 113, 210);
      border: 1px solid rgb(10, 113, 210);
      border-radius: 25px;
      padding: 10px 25px;
    }
    .even-content {
      color: white;
      background-color: rgb(4, 109, 209);
    }
  }
}
@media (max-width: 1300px) {
  .company-introduce,
  .company-news {
    padding: 0 50px;
    margin-top: 100px;
  }
  .company-introduce-left,
  .company-introduce-right {
    flex-shrink: 1; /* 允许收缩 */
  }
  .news-title,
  .introduce-title {
    font-size: var(--smallTitleFontSize) !important;
  }
  .news-content,
  .introduce-content {
    font-size: var(--smallContentFontSize) !important;
  }
}
@media (max-width: 768px) {
  .company-introduce {
    flex-wrap: wrap;
  }
  .company-introduce-left,
  .company-introduce-right {
    width: 100%;
    flex: none;
  }
  .news-title,
  .introduce-title {
    font-size: var(--contentFontSize) !important;
  }
  .news-content,
  .introduce-content {
    font-size: var(--miniContentFontSize) !important;
  }
}
</style>